import { Tooltip } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import UsualUpload from '@/pages/pageComponents/AgentUpload/Upload/UsualUpload';
import s from '../style.module.scss';
import { useRef } from 'react';
const UsualSkillFileUpload = (props) => {
    const { setAgentFile, agentFile, setReferences, authTest } = props;
    const canOpen = useRef(false);
    const divRef = useRef();
    const onClick = async (e) => {
        if (!canOpen.current) {
            console.log('阻止了');
            e.preventDefault();
            e.stopPropagation(); // 阻止事件冒泡到 Upload 组件
            let res = await authTest();
            if (res) {
                canOpen.current = true;
                divRef.current?.click();
            }
        }
    };
    return (
        <>
            <UsualUpload
                setAgentFile={setAgentFile}
                agentFile={agentFile}
                setReferences={setReferences}
                uploadItem={
                    <div
                        onClick={onClick}
                        ref={divRef}
                        data-type={'file'}
                        style={{ height: 32 }}
                        data-disabled={agentFile.length > 4}
                        className={`${s['plugin-item']}`}
                    >
                        <Tooltip title={agentFile.length > 4 ? null : '上传附件'}>
                            <PaperClipOutlined />
                        </Tooltip>
                    </div>
                }
            ></UsualUpload>
        </>
    );
};
export default UsualSkillFileUpload;
